import { render } from "./language.vue?vue&type=template&id=6351187d"
import script from "./language.vue?vue&type=script&lang=ts"
export * from "./language.vue?vue&type=script&lang=ts"
script.render = render

export default script